module.exports = __webpack_public_path__ + "static/media/client-lank.5d134bde.png";